/* Collection Editorial — flavor jump nav: smooth scroll + scroll-spy.
   Progressive enhancement: the anchor links work without JS; this adds active
   highlighting and reduced-motion-aware smooth scrolling. Scoped per section. */
(function () {
  function initSection(root) {
    var nav = root.querySelector('.ce-nav');
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('.ce-nav__link'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.ce-row[id]'));
    if (!links.length || !rows.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function idFromHref(link) {
      var href = link.getAttribute('href') || '';
      return href.charAt(0) === '#' ? href.slice(1) : '';
    }

    function setActive(id) {
      links.forEach(function (link) {
        if (idFromHref(link) === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    // Smooth scroll on click (scoped; respects reduced motion).
    // Native anchor jump remains the fallback if anything is missing.
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = idFromHref(link);
        var target = id && document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        setActive(id);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    // Scroll-spy: highlight the flavor nearest the viewport centre.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.target.id) setActive(entry.target.id);
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );
      rows.forEach(function (row) {
        observer.observe(row);
      });
    }

    setActive(rows[0].id);
  }

  function initAll() {
    document.querySelectorAll('.collection-editorial').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('.collection-editorial')
        : null;
    if (section) initSection(section);
  });
})();
